import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";

import {
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
  STATE_IDENTIFIER,
} from "./constants";

const {
  APPLICATIONS,
  TOTAL_APPLICATIONS,
  SELECTED_APPLICATION,
  SELECTED_APPLICATION_CONFIGURATION,
  TEMPORARY_ABILITATIONS,
  ADDED,
  REMOVED,
  TOTAL,
  PREVIOUS,
  SELECTED_TEMPORARY_ABILITATION,
  CONFIGURATIONS,
  BASIC_CONFIGURATION,
  EMERGENCY_CONFIGURATION,
  ROLES,
  NEW_ADDED_ROLES,
  FIELDS,
  REQUEST_STATE,
  REQUEST_STATE_ROLES_CREATION,
  SYSTEM_USERS,
  EDIT_EMERGENCY_CONFIGURATION,
  GLOBAL_CATALOG,
  SELECTED_EMERGENCY_CONFIGURATION,
  EMERGENCY_ADDED_ENTITLEMENTS,
  EMERGENCY_DELETED_ENTITLEMENTS,
  EMERGENCY_TOTAL_ENTITLEMENTS,
  UPDATE_EMERGENCY_CONFIGURATION_CALL_STATE,
} = STATE_IDENTIFIER;

export default {
  [SYSTEM_USERS]: [],
  [APPLICATIONS]: {
    [LIST_IDENTIFIER]: [],
    [LOADER_IDENTIFIER]: false,
    [TOTAL_APPLICATIONS]: [],
    [SELECTED_APPLICATION]: [],
    [SELECTED_APPLICATION_CONFIGURATION]: {},
    [TEMPORARY_ABILITATIONS]: {
      [LIST_IDENTIFIER]: [],
      [LOADER_IDENTIFIER]: false,
      [ADDED]: [],
      [REMOVED]: [],
      [TOTAL]: [],
      [PREVIOUS]: {
        [LIST_IDENTIFIER]: [],
        [LOADER_IDENTIFIER]: false,
      },
    },
  },
  [TEMPORARY_ABILITATIONS]: {
    [LIST_IDENTIFIER]: [],
    [LOADER_IDENTIFIER]: false,
    [SELECTED_TEMPORARY_ABILITATION]: [],
    [CONFIGURATIONS]: {
      [LOADER_IDENTIFIER]: false,
      [BASIC_CONFIGURATION]: [],
      [EMERGENCY_CONFIGURATION]: [],
    },
    [EDIT_EMERGENCY_CONFIGURATION]: {
      [SELECTED_EMERGENCY_CONFIGURATION]: null,
      [GLOBAL_CATALOG]: {
        [LIST_IDENTIFIER]: [],
        [LOADER_IDENTIFIER]: false,
      },
      [EMERGENCY_ADDED_ENTITLEMENTS]: [],
      [EMERGENCY_DELETED_ENTITLEMENTS]: [],
      [EMERGENCY_TOTAL_ENTITLEMENTS]: [],
      [UPDATE_EMERGENCY_CONFIGURATION_CALL_STATE]: IResponseState.PENDING,
    },
    [ROLES]: {
      [LIST_IDENTIFIER]: [],
      [LOADER_IDENTIFIER]: false,
      [NEW_ADDED_ROLES]: [],
      [REQUEST_STATE_ROLES_CREATION]: IResponseState.PENDING,
    },
    [FIELDS]: {
      [LIST_IDENTIFIER]: [],
      [LOADER_IDENTIFIER]: false,
    },
  },
  [REQUEST_STATE]: IResponseState.PENDING,
};
